import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div style={{padding:'20px', textAlign:'center'}}>Loading...</div>;
  
  // 1. If not logged in -> Login
  if (!user) {
      return <Navigate to="/login" />;
  }

  // 2. 👇 NEW: If logged in but Suspended -> Suspended Page
  if (user.status === 'suspended') {
      return <Navigate to="/account-suspended" />;
  }
  
  // 3. Allowed
  return children;
};

export default PrivateRoute;